import React from 'react'
import { getClientSettings } from '../../services/auth.service'
import { UserManager } from 'oidc-client'
import { RouteComponentProps } from 'react-router'
import { appRoutes } from '../../constants/routes'
import { Container, Alert } from 'react-bootstrap'
import { DefaultSpinner } from '../pageBlocks/Spinners'
import { appConstants } from '../../constants/appConstants'
import { appInsights } from '../../appInsights'

function CallbackPage({ history }: RouteComponentProps<any>) {
	const [error, setError] = React.useState<Error>()

	const signin = React.useCallback(async () => {
		const signingRequestId = localStorage.getItem(
			appConstants.signingRequestId,
		)

		const userManager = new UserManager(getClientSettings('query'))

		try {
			if (window.location.search.indexOf('code') === -1) {
				await userManager.signinRedirect() // calls /authorize endpoint in id server and then redirects back to /callback page (as that is the redirect_url defined in auth.services.ts)
				return
			} else if (window.location.search.indexOf('code') > -1) {
				await userManager.signinCallback() // this is when the user gets logged in
				if (signingRequestId) {
					localStorage.removeItem(appConstants.signingRequestId)
				}
				window.location.replace(
					`${appRoutes.signRoot}/${signingRequestId ? signingRequestId + '/authenticated' : ''}`,
				)
			}
		} catch (exception) {
			appInsights.trackException({ exception })
			setError(exception)
		}
	}, [history])

	React.useEffect(() => {
		signin()
	}, [signin])

	return (
		<Container className="callbackPage">
			{error ? (
				<Alert
					variant="danger"
					dismissible
					onClose={() => {
						setError(undefined)
						window.location.replace(
							`${window.location.origin + appRoutes.logout}`,
						)
					}}>
					{error.message}
				</Alert>
			) : (
				<DefaultSpinner />
			)}
		</Container>
	)
}

export default CallbackPage
